import { db, storage } from "../../../firebase/firebase-config";

export const getResumenCard = async (key) => {
  const doc = await db.collection("resumen_config").doc(key).get();
  return doc.exists ? { id: doc.id, ...doc.data() } : null;
};

export const setResumenCard = async (key, data, file) => {
  let imageURL = data.imageURL || "";

  if (file) {
    const safeName = file.name.replace(/[^\w.-]/g, "_");
    const ref = storage.ref().child(`resumen_config/${key}/${Date.now()}_${safeName}`);
    await ref.put(file);
    imageURL = await ref.getDownloadURL();
  }

  await db.collection("resumen_config").doc(key).set(
    {
      label: data.label || "",
      clickMe: data.clickMe || "",
      imageURL,
      updatedAt: new Date().toISOString(),
    },
    { merge: true }
  );
};
